// extracted by mini-css-extract-plugin
module.exports = {"squares":"_3hL13Tq7In6-eS5NYkCnZM","countCard":"_23HmmGLAcZZlh2tLTsfasE"};